<template>
  <div class="ActiveList">
    <el-form
      ref="activeForm"
      :inline="true"
      :model="activeForm"
      class="demo-form-inline"
      :rules="activeRule"
    >
      <el-form-item label="活动名称" prop="name">
        <el-input
          v-model.trim="activeForm.name"
          placeholder="请输入活动名称"
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="活动时间" prop="time">
        <el-date-picker
          v-model="activeForm.time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          style="z-index: 9999; position:relative; z-index: 9999"
        ></el-date-picker>
      </el-form-item>
    </el-form>

    <div class="editor-container">
      <div ref="editorElem" style="height: 500px;"></div>
    </div>
    <div style="display: flex; justify-content: center">
      <el-button
        :size="size"
        type="primary"
        plain
        @click.native="submitForm"
        :loading="sureLoading"
        >保存</el-button
      >
      <el-button :size="size" plain @click.native="back" :loading="sureLoading"
        >返回</el-button
      >
    </div>
  </div>
</template>
<script>
import wangEditor from 'wangeditor'
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "ActiveList",
  data() {
    return {
      activeForm: {
        name: "",
        time: "",
        postPic: "",
      },
      isAdd: false, //判断是添加还是修改
      activeId: "", //活动id
      activeName: "first",
      fileList: [], // 图片回显
      firstPicList: [],
      groupId: "", //机构id
      size: "medium", //按钮的尺寸
      sureLoading: false, //按钮加载
      remarkLength: "", //富文本字符长度
      defaultMsg: "",
      editor:null,
      content: "",
      dataForm: {
        remark: "",
      },
      activeRule: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "活动名称最多只能输入20个字符",
            trigger: "blur",
          },
        ],
        time: [
          { required: true, message: "请输入活动时间", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    //返回按钮
    back() {
      bus.$emit("close_current_tags");
    },
    //富文本编辑框回显数据
    setUEContent(val) {
      this.content = val;
      this.editor.txt.html(val)
    },

    /* 
      点击提交数据
    */
    submitForm() {
      this.upResource();
    },
    /* 
      上传的资源
    */
    upResource() {
      this.$refs.activeForm.validate((valid) => {
        if (valid) {
          let remark =  this.content
            .replace(/<[^<>]+>/g, "")
            .replace(/&nbsp;/gi, "");
          let params = {
            //id: this.activeId,
            activityName: this.activeForm.name,
            activity: this.content,
            activityType: 2,
            remark: remark,
            startTime: this.activeForm.time[0],
            endTime: this.activeForm.time[1],
          };
          if (!this.isAdd) {
            params.id = this.activeId;
          }
          this.$postJson(
            this.isAdd
              ? "omc/queryMachine/addActivity"
              : "omc/queryMachine/editActivity",
            params
          ).then((res) => {
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
              bus.$emit('close_current_tags');
            } else {
              this.$message({ message: res.message, type: "error" });
            }
          });
        } else {
          return false;
        }
      });
    },

    //数据回显
    backDetail(id) {
      this.fileList = [];
      let params = {
        id: id,
      };
      this.$postJson("omc/queryMachine/queryActivitiesWithPage", params).then(
        (res) => {
          this.setUEContent(res.result.list[0].activity); //加载完成调取函数回显富文本框的数据
          this.activeForm.name = res.result.list[0].activityName;
          this.activeForm.time = [
            res.result.list[0].startTime,
            res.result.list[0].endTime,
          ];
        }
      );
    },
  },
  created() {
    this.groupId = sessionStorage.getItem("groupId");
  },
  mounted() {
    this.editor = new wangEditor(this.$refs.editorElem);
    // 配置编辑器
    this.editor.config.uploadImgShowBase64 = false; // 显示Base64编码的图片
    this.editor.config.uploadImgMaxLength = 3 * 1024 * 1024; // 限制上传图片的大小为5MB
    this.editor.config.emotions = null;
    this.editor.config.onchange = html => {
      this.content = html;
    };
    // 创建编辑器
    this.editor.create();
    console.log(this.dataForm.remark);
    console.log(this.$route.query.id);
    this.activeId = this.$route.query.id;
    this.isAdd = this.$route.query.add;
    if (this.$route.query.id) {
      this.backDetail(this.$route.query.id);
    }
  },
};
</script>
<style lang="scss" scoped>
.ActiveList {
  background: #fff;
  width: 100%;
  height: 100%;
  .editor-container {
    width: 100%;
    height: 600px;
    z-index: 1;
    position: relative;
  }
}

::v-deep .w-e-text-container{
  height: 98% !important;
}

</style>